import { cn } from "@utils";
import * as React from "react";

const Button = React.forwardRef(({ className, ...props }, ref) => (
  <button
    className={cn(
      "inline-flex items-center justify-center gap-x-2 whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
      className
    )}
    ref={ref}
    {...props}
  />
));

Button.displayName = "Button";

export { Button };
